import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { getUserCategories } from "../Apis/Category";
import { query_stale_time } from "../Helpers/Helpers";
import { userState } from "../Recoil";
import { vendor_login, vendor_register } from "../Util/connection_strings";
import { withRouter } from "react-router-dom";
import { AiOutlineHeart } from "react-icons/ai";
import { IoIosLogOut } from "react-icons/io";
import { FaRegBell, FaRegUser, FaUserCircle, FaClipboardList } from "react-icons/fa";

import { RxAvatar } from "react-icons/rx";
import { getCount } from "../Apis/Notification";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import ReactLanguageSelect from 'react-languages-select';

import 'react-languages-select/css/react-languages-select.css';
// import {PiMapPinLine} from "react-icons/pi"

function Header({ history, location }) {
  const user = useRecoilValue(userState);
  const [categories, setCategories] = useState([]);
  const [cart_quantity, setCartQuantity] = useState(0);

  console.log(">>>>", user?._id);
  const { isLoading, data } = useQuery(
    ["categories"],
    () => getUserCategories(),
    {
      staleTime: query_stale_time,
      onSuccess: (res) => {
        setCategories(res?.data?.categories);
      },
    }
  );

  const { data: notification_count_data } = useQuery(
    ["notificaiton_count", location?.pathname],
    () => getCount(),
    {
      staleTime: query_stale_time,
      cacheTime: 1000,
    }
  );

  useEffect(() => {
    let cart = localStorage.getItem("cart");
    if (cart) {
      cart = JSON.parse(cart);
      setCartQuantity(cart.length);
    }
  }, [localStorage.getItem("cart")]);



  //  off canvas start form here //

    const [isOpen, setIsOpen] = useState(false);

  // Create and remove backdrop manually
  useEffect(() => {
    let backdrop;

    if (isOpen) {
      // Show backdrop
      backdrop = document.createElement("div");
      backdrop.className = "offcanvas-backdrop fade show";
      document.body.appendChild(backdrop);
      document.body.style.overflow = "hidden";

      // Close when clicking backdrop
      backdrop.addEventListener("click", () => setIsOpen(false));
    } else {
      // Remove backdrop
      const existingBackdrop = document.querySelector(".offcanvas-backdrop");
      if (existingBackdrop) existingBackdrop.remove();
      document.body.style.overflow = "";
    }

    return () => {
      if (backdrop) backdrop.remove();
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close the menu when link clicked
  const handleClose = () => setIsOpen(false);

  // off canvas end form here //

  return (
    <>
      <div className="topArea" style={{backgroundColor:"#643DCE"}}>
        <div className="container-fluid">
          <div className="row " >
            <div className="col-6"><p style={{ margin: 0 }}>Free Shipping all over the USA</p></div>
            <div className="col-6" style={{ textAlign: "right", display: 'flex', justifyContent: 'flex-end' }}>
              <Link to="/location">
                <button className="headerBtn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 19 24" fill="none">
                    <path d="M13.7717 7.79132C13.7717 5.26859 11.7486 3.21384 9.2579 3.21384C6.77026 3.21384 4.7441 5.2655 4.7441 7.79132C4.7441 10.314 6.76721 12.3688 9.2579 12.3688C11.7455 12.3688 13.7717 10.314 13.7717 7.79132ZM5.85345 7.79132C5.85345 5.88843 7.38148 4.33884 9.2579 4.33884C11.1343 4.33884 12.6623 5.88843 12.6623 7.79132C12.6623 9.69421 11.1343 11.2438 9.2579 11.2438C7.38148 11.2438 5.85345 9.69421 5.85345 7.79132ZM18.478 23.2345L16.0882 16.999C16.0057 16.782 15.8009 16.6395 15.5717 16.6395H12.4331L12.9832 15.8306C13.3102 15.3502 13.6708 14.8667 14.0192 14.3957C15.4556 12.4618 16.9439 10.4597 16.9439 7.79442C16.9439 3.49587 13.4966 0 9.2579 0C5.01914 0 1.57191 3.50207 1.57191 7.79752C1.57191 10.4628 3.05715 12.4618 4.4935 14.3957C4.84189 14.8636 5.20251 15.3502 5.5295 15.8306L6.0796 16.6395H2.94408C2.71487 16.6395 2.51012 16.782 2.42761 16.999L0.0377683 23.2345C-0.029465 23.4081 -0.00501635 23.6033 0.0958336 23.7552C0.196684 23.907 0.370879 24 0.554242 24H17.9585C18.1419 24 18.313 23.907 18.4169 23.7552C18.5208 23.6033 18.5422 23.4081 18.478 23.2345ZM5.38281 13.7231C3.99536 11.8543 2.68431 10.0878 2.68431 7.80062C2.68431 4.1219 5.63341 1.1312 9.26095 1.1312C12.8885 1.1312 15.8376 4.1219 15.8376 7.80062C15.8376 10.0909 14.5265 11.8543 13.136 13.7262C12.7815 14.2035 12.4148 14.6994 12.0725 15.1983L9.26095 19.3326L6.44938 15.1983C6.10404 14.6963 5.73732 14.2004 5.38281 13.7231ZM1.3641 22.875L3.32303 17.7645H6.84361L8.79949 20.6374C8.90339 20.7893 9.07453 20.8791 9.25484 20.8791C9.43515 20.8791 9.60629 20.7893 9.71019 20.6374L11.6661 17.7645H15.1866L17.1456 22.875H1.3641Z" fill="white" />
                  </svg> &nbsp; Store Location
                </button>
              </Link>
              {user?._id && <> &emsp; |&emsp; <Link to="/order/logs"><button className="headerBtn"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 34 25" fill="none">
                <path d="M28.4139 6.889C28.3633 6.81032 28.2937 6.74561 28.2116 6.70079C28.1295 6.65597 28.0374 6.63248 27.9439 6.63248H22.3551V3.27921C22.3551 3.13099 22.2962 2.98884 22.1914 2.88403C22.0866 2.77922 21.9444 2.72034 21.7962 2.72034H0.558877C0.410654 2.72034 0.268501 2.77922 0.163691 2.88403C0.0588815 2.98884 0 3.13099 0 3.27921V21.1633C0 21.3115 0.0588815 21.4537 0.163691 21.5585C0.268501 21.6633 0.410654 21.7222 0.558877 21.7222H4.52132C4.65267 22.5032 5.05655 23.2124 5.66123 23.7239C6.26592 24.2354 7.03229 24.516 7.82428 24.516C8.61628 24.516 9.38265 24.2354 9.98734 23.7239C10.592 23.2124 10.9959 22.5032 11.1272 21.7222H23.5231C23.6545 22.5032 24.0584 23.2124 24.6631 23.7239C25.2677 24.2354 26.0341 24.516 26.8261 24.516C27.6181 24.516 28.3845 24.2354 28.9892 23.7239C29.5939 23.2124 29.9977 22.5032 30.1291 21.7222H32.9738C33.122 21.7222 33.2641 21.6633 33.369 21.5585C33.4738 21.4537 33.5326 21.3115 33.5326 21.1633V15.0156C33.5326 14.9084 33.5018 14.8035 33.4438 14.7133L28.4139 6.889ZM29.0616 9.96339L31.5905 13.8979H24.5906V9.98574H29.0616V9.96339ZM7.82428 23.3988C7.38214 23.3988 6.94993 23.2677 6.5823 23.022C6.21467 22.7764 5.92814 22.4273 5.75894 22.0188C5.58974 21.6103 5.54547 21.1608 5.63173 20.7272C5.71799 20.2935 5.9309 19.8952 6.24354 19.5825C6.55618 19.2699 6.95451 19.057 7.38816 18.9707C7.8218 18.8845 8.27129 18.9287 8.67978 19.0979C9.08826 19.2672 9.4374 19.5537 9.68304 19.9213C9.92868 20.2889 10.0598 20.7211 10.0598 21.1633C10.0598 21.7562 9.82427 22.3248 9.40503 22.744C8.98579 23.1633 8.41718 23.3988 7.82428 23.3988ZM7.82428 17.81C7.03261 17.8115 6.26692 18.0927 5.66253 18.6041C5.05813 19.1154 4.65392 19.8239 4.52132 20.6044H1.11775V19.4867H3.91214V18.3689H1.11775V3.83809H21.2373V4.95585H2.23551V6.0736H21.2373V18.3689H11.7364V19.4867H21.2373V20.6044H11.1272C10.9946 19.8239 10.5904 19.1154 9.98604 18.6041C9.38164 18.0927 8.61596 17.8115 7.82428 17.81ZM26.8261 23.3988C26.384 23.3988 25.9518 23.2677 25.5841 23.022C25.2165 22.7764 24.93 22.4273 24.7608 22.0188C24.5916 21.6103 24.5473 21.1608 24.6336 20.7272C24.7198 20.2935 24.9327 19.8952 25.2454 19.5825C25.558 19.2699 25.9563 19.057 26.39 18.9707C26.8236 18.8845 27.2731 18.9287 27.6816 19.0979C28.0901 19.2672 28.4392 19.5537 28.6849 19.9213C28.9305 20.2889 29.0616 20.7211 29.0616 21.1633C29.0616 21.7562 28.8261 22.3248 28.4069 22.744C27.9876 23.1633 27.419 23.3988 26.8261 23.3988ZM30.1291 20.6044C29.9977 19.8234 29.5939 19.1142 28.9892 18.6027C28.3845 18.0912 27.6181 17.8106 26.8261 17.8106C26.0341 17.8106 25.2677 18.0912 24.6631 18.6027C24.0584 19.1142 23.6545 19.8234 23.5231 20.6044H22.3551V7.75023H27.6387L28.3574 8.86799H24.0317C23.8835 8.86799 23.7414 8.92687 23.6365 9.03168C23.5317 9.13649 23.4729 9.27864 23.4729 9.42687V14.4568C23.4729 14.605 23.5317 14.7471 23.6365 14.8519C23.7414 14.9568 23.8835 15.0156 24.0317 15.0156H32.3093L32.4149 15.1799V18.3689H30.7383V19.4867H32.4149V20.6044H30.1291Z" fill="white" />
                <path d="M8.38326 20.6045H7.2655V21.7222H8.38326V20.6045Z" fill="white" />
                <path d="M27.3848 20.6045H26.2671V21.7222H27.3848V20.6045Z" fill="white" />
                <path d="M10.0598 0.484863H2.23547V1.60262H10.0598V0.484863Z" fill="white" />
                <path d="M1.11775 0.484863H0V1.60262H1.11775V0.484863Z" fill="white" />
              </svg>  &nbsp;  Order Status </button></Link></>}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="topArea1">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="row align-items-center gx-1">
              <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="d-flex align-items-center">
                <div className="d-flex justify-content-start align-items-center">
                <ul className="topRightlist">
                  <li> <label className="" >
                    <i className="topLeftIcon"><img src="images/location.png" /></i>
                    Store Location
                  </label></li>
                  <li><label className="" >
                    <i className="topLeftIcon" ><img src="images/order.png" /></i>
                    Order Status
                  </label></li>
                  <li><label className="" >
                    <i className="topLeftIcon" ><img src="images/helpline.png" /></i>
                    Hotline: (1234) 1234 54000
                  </label></li>
                </ul>
                 
                  
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 d-lg-flex d-block justify-content-end ">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                <ul className="topRightlist">
                  <li> <label className="" >
                  Free Shipping for order over £80!
                  </label></li>
                  <li><label className="" >
                  <ReactLanguageSelect
    searchable={true}
    languages={["en", "fr", "de", "it", "es"]}
    searchPlaceholder="Search for a language" />
                 
                  </label></li>
                </ul>
                 
                  
                  
                </div>
                
              </div>
            </div>
              </div>
            </div>
            
           
            
          </div>
        </div>
      </div> */}
      <div className="top-nav">
        <div className="container-fluid">

          <div className="row justify-content-center">
            <div className="col-lg-11 headerMenu">
              <div className="row align-items-center">
                <div className="col-6 d-block d-sm-none">
                   <Link to="/" className="nav-link p-1">
                        <img src="images/logo.png" width="120" alt="Logo" /> <span className="sr-only">(current)</span>
                      </Link>
                </div>
                 <div className="col-6 d-block d-sm-none text-end">
                  {/* Menu Button */}
      <button
        className="btn btn1 px-3 py-2"
        type="button"
        onClick={() => setIsOpen(true)}
      >
        ☰
      </button>

      {/* Offcanvas Menu */}
      <div
        id="offcanvasMenu"
        className={`offcanvas offcanvas-start ${isOpen ? "show" : ""}`}
        style={{
          visibility: isOpen ? "visible" : "hidden",
          transform: isOpen ? "none" : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out, visibility 0.3s ease-in-out",
        }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Main Menu</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setIsOpen(false)}
          ></button>
        </div>

        <div className="offcanvas-body">
          <ul className="list-unstyled offcanvas-links">
            <li>
              <Link to="/" className="nav-link p-1" onClick={handleClose}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/products" className="nav-link p-1" onClick={handleClose}>
                Shop
              </Link>
            </li>
            <li>
              <Link to="/contact-us" className="nav-link p-1" onClick={handleClose}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/vendorvideo" className="nav-link p-1" onClick={handleClose}>
                Video for Vendor
              </Link>
            </li>
            <li>
              <a
                className="nav-link p-1"
                href="https://predivauthmarketplace.com/vendor"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClose}
              >
                Signup/Login as a Vendor
              </a>
            </li>
          </ul>
        </div>
      </div>

    
                    {/* <div className="offcanvas offcanvas-start" tabindex="-1" id="offcanvasMenu">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title">Main Menu</h5>
    <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
  </div>
  <div className="offcanvas-body">
    <ul className="list-unstyled offcanvas-links">
      
                    <li>
                      <Link to="/" className="nav-link p-1">
                        Home <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                   
                    <li>
                      <Link to="/products" className="nav-link p-1">
                        Shop
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link p-1" to="/contact-us">
                        Contact
                      </Link>
                    </li>
                     <li>
                      <Link className="nav-link p-1" to="/vendorvideo">
                        Video for Vendor
                      </Link>
                    </li>
                    <li>
                          <a
                            className="nav-link p-1"
                            href="https://predivauthmarketplace.com/vendor"
                            target="_blank"   // opens in a new tab
                            rel="noopener noreferrer" // security best practice
                          >
                             Signup/Login as a Vendor
                          </a>
                        </li>
    </ul>
  </div>
                    </div> */}
                    
    
                </div>
                
               
                <div className="col-lg-8 col-md-12 d-none d-sm-block">
                   
                  <ul>
                    <li>
                      <Link to="/" className="nav-link p-1">
                        <img src="images/logo.png" width="120" alt="Logo" /> <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="nav-link p-1">
                        Home <span className="sr-only">(current)</span>
                      </Link>
                    </li>
                   
                    <li>
                      <Link to="/products" className="nav-link p-1">
                        Shop
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link p-1" to="/contact-us">
                        Contact
                      </Link>
                    </li>
                     <li>
                      <Link className="nav-link p-1" to="/vendorvideo">
                        Video for Vendor
                      </Link>
                    </li>
                    <li>
                          <a
                            className="nav-link p-1"
                            href="https://predivauthmarketplace.com/vendor"
                            target="_blank"   // opens in a new tab
                            rel="noopener noreferrer" // security best practice
                          >
                             Signup/Login as a Vendor
                          </a>
                        </li>

                  </ul>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-6">
                  {user?._id ? (

                    <div className="row justify-content-end align-items-center">
                      <div className="col-lg-5 col-md-6 col-sm-8">

                        <div className="searchArea ">
                          <input placeholder='Search Product Here...... ' type="search" className="flex-grow-3 w-100" />

                          <button className="flex-shrink-1 d-flex">
                            {" "}
                            <Link to="/products">
                              <i>
                                <img src="images/search.png" />
                              </i>
                            </Link>
                          </button>
                        </div>

                      </div>
                      <div className="col-1 d-flex flex-column  caretNone ">
                        <div className="dropdown">
                          <div
                            className="transparent dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <p className="m-0"><FaRegUser style={{ fontSize: "20px", color: "black" }} /></p>
                            {/* <h6 className="m-0">{user.name}</h6> */}
                          </div>
                          <ul className="dropdown-menu">
                            <li>
                              {" "}
                              <Link className="dropdown-item" to="/profile">
                                <FaUserCircle /> My Profile
                              </Link>
                            </li>
                            <li>
                              {" "}
                              <Link className="dropdown-item" to="/order/logs">
                                <FaClipboardList /> Order Log
                              </Link>
                            </li>
                            <li>
                              {" "}
                              <Link
                                className="dropdown-item"
                                to="#"
                                data-toggle="modal"
                                data-target="#exampleModalCenter"
                                onClick={() => {
                                  localStorage.clear();
                                  window.location.reload();
                                  window.location.href = "/";
                                }}
                              >
                                <IoIosLogOut /> Logout
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-1 d-flex align-items-center">
                        <div className="cart">
                          <Link to="/wishlist">
                            <AiOutlineHeart
                              style={{ fontSize: "20px", color: "black" }}
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="col-1 d-flex align-items-center ">
                        <div className="cart" >
                          <Link className to="/cart">
                            <div style={{ position: 'relative', fontSize: "20px", color: "black", marginTop: "25px" }}>
                              <img src="images/cart.png" />
                              &emsp;
                              <span className="badge-green">{cart_quantity}</span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-8 d-flex flex-column text-center justify-content-center">
                        <Link
                          to="/login"
                          className="loginBtn"
                          style={{ textDecoration: "none" }}
                        >
                          <p className="m-0">Hello, Signin</p>
                          <h6 className="m-0">Account</h6>
                        </Link>
                      </div>

                      <div className="col-4 d-flex align-items-center">
                        <div className="cart">
                          <Link className to="/cart">
                            <div style={{ position: 'relative' }}>
                              <svg
                                width="24"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#333333"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                transform="scale(-1.4,1.4)"
                              >
                                <path d="M13.5 18c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm-3.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm14-16.5l-.743 2h-1.929l-3.473 12h-13.239l-4.616-11h2.169l3.776 9h10.428l3.432-12h4.195zm-17 4h8v2h-8v-2z" />
                              </svg>&emsp; <strong style={{ fontSize: 14, position: "absolute", bottom: 2 }}>Cart</strong>

                              <span className="badge-green" style={{ left: 6, top: 0 }}>{cart_quantity}</span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                


              </div>

            </div>
          </div>
        </div>
      </div>



    </>
  );
}

export default withRouter(Header);
